import { Col, Container, Row } from 'react-bootstrap';
import Button from '../../../../components/Button';
import { ButtonContainer } from '../../../../components/Form';
import Loader from '../../../../components/Loader';
import OpacityAnimation from '../../../../components/OpacityAnimation';
import PageHeader from '../../../../components/PageHeader';
import { useQuery } from '../../../../hooks/useQuery';
import AddressDataCard from './components/AddressDataCard';
import GeneralDataCard from './components/GeneralDataCard';
import useWorkplaceForm from './useWorkplaceForm';

export default function WorkplaceForm({ edit }: { edit: boolean }) {
  const {
    isLoading,
    name,
    getErrorMessageByFieldName,
    workplaceCode,
    handleWorkplaceCodeChange,
    handleNameChange,
    hasAffreightment,
    setHasAffreightment,
    operator,
    operatorsOptions,
    setOperator,
    usesVtAndAffreightment,
    setUsesVtAndAffreightment,
    cep,
    handleCepChange,
    streetName,
    number,
    handleNumberChange,
    district,
    city,
    uf,
    lat,
    handleLatChange,
    lng,
    handleLngChange,
    isFormValid,
    updateWorkplace,
    createWorkplace,
    isSubmitting,
    checkIfWorkplaceCodeAlreadyExists,
    handleStreetNameChange,
    handleDistrictChange,
    handleCityChange,
    handleUfChange,
    setError,
    setIsLoading,
    removeError,
    selectedWalkDistance,
    handleWalkDistanceSelection,
    setSelectedWalkDistance,
    compareWithDesiredVtValue,
    handleCompareWithDesiredVtValueChange,
    desiredVtValue,
    handleDesiredVtValueChange,
    sameWalkDistanceFromCompany,
    handleSameWalkDistanceFromCompanyChange,
    sameDesiredVtValueFromCompany,
    handleSameDesiredVtValueFromCompanyChange,
    hasKmLimit,
    setHasKmLimit,
    selectedKmLimit,
    setSelectedKmLimit,
    // kmLimit,
    kindOfVtSpTrans,
    setKindOfVtSpTrans,
    integratesWithRiocard,
    setIntegratesWithRiocard,
    handleKmLimitSelection,
    transfersBehavior,
    setTransfersBehavior,
    companyTransfersBehavior,
    sameTransfersBehaviorFromCompany,
    handleSameTransfersBehaviorFromCompanyChange,
    // setKmLimit,
  } = useWorkplaceForm();

  const query = useQuery();
  const returnLink = query.get('returnLink');


  return (
    <>
      <Loader isLoading={isLoading || isSubmitting} />
      {edit && (
        <PageHeader
          title={`Editar Local ${name}`}
          link={returnLink ? returnLink : '/workplaces'}
        />
      )}

      {!edit && (
        <PageHeader
          title="Adicionar novo local"
          link="/workplaces"
        />
      )}

      <Container>
        <Row xs={1} md={1} lg={1}>
          <Col>
            <OpacityAnimation>
              <GeneralDataCard
                getErrorMessageByFieldName={getErrorMessageByFieldName}
                workplaceCode={workplaceCode}
                handleWorkplaceCodeChange={handleWorkplaceCodeChange}
                name={name}
                handleNameChange={handleNameChange}
                hasAffreightment={hasAffreightment}
                setHasAffreightment={setHasAffreightment}
                operator={operator}
                operatorsOptions={operatorsOptions}
                setOperator={setOperator}
                usesVtAndAffreightment={usesVtAndAffreightment}
                setUsesVtAndAffreightment={setUsesVtAndAffreightment}
                checkIfWorkplaceCodeAlreadyExists={checkIfWorkplaceCodeAlreadyExists}
                selectedWalkDistance={selectedWalkDistance}
                handleWalkDistanceSelection={handleWalkDistanceSelection}
                setSelectedWalkDistance={setSelectedWalkDistance}
                compareWithDesiredVtValue={compareWithDesiredVtValue}
                handleCompareWithDesiredVtValueChange={handleCompareWithDesiredVtValueChange}
                desiredVtValue={desiredVtValue}
                handleDesiredVtValueChange={handleDesiredVtValueChange}
                sameWalkDistanceFromCompany={sameWalkDistanceFromCompany}
                handleSameWalkDistanceFromCompanyChange={handleSameWalkDistanceFromCompanyChange}
                sameDesiredVtValueFromCompany={sameDesiredVtValueFromCompany}
                handleSameDesiredVtValueFromCompanyChange={handleSameDesiredVtValueFromCompanyChange}
                kindOfVtSpTrans={kindOfVtSpTrans}
                setKindOfVtSpTrans={setKindOfVtSpTrans}
                integratesWithRiocard={integratesWithRiocard}
                setIntegratesWithRiocard={setIntegratesWithRiocard}
                hasKmLimit={hasKmLimit}
                setHasKmLimit={setHasKmLimit}
                selectedKmLimit={selectedKmLimit}
                handleKmLimitSelection={handleKmLimitSelection}
                setSelectedKmLimit={setSelectedKmLimit}
                transfersBehavior={transfersBehavior}
                setTransfersBehavior={setTransfersBehavior}
                companyTransfersBehavior={companyTransfersBehavior}
                sameTransfersBehaviorFromCompany={sameTransfersBehaviorFromCompany}
                handleSameTransfersBehaviorFromCompanyChange={handleSameTransfersBehaviorFromCompanyChange}
              />
            </OpacityAnimation>
          </Col>

          <Col>
            <OpacityAnimation>
              <AddressDataCard
                lat={lat}
                lng={lng}
                cep={cep}
                streetName={streetName}
                number={number}
                district={district}
                city={city}
                uf={uf}
                handleLatChange={handleLatChange}
                handleLngChange={handleLngChange}
                handleCepChange={handleCepChange}
                handleStreetNameChange={handleStreetNameChange}
                handleNumberChange={handleNumberChange}
                handleDistrictChange={handleDistrictChange}
                handleCityChange={handleCityChange}
                handleUfChange={handleUfChange}
                setError={setError}
                setIsLoading={setIsLoading}
                removeError={removeError}
                getErrorMessageByFieldName={getErrorMessageByFieldName}
              />
            </OpacityAnimation>
          </Col>
        </Row>

        <ButtonContainer>
          {edit && (
            <Button disabled={!isFormValid} onClick={() => updateWorkplace()}>
              {`Salvar Local ${name ?? ''}`}
            </Button>
          )}

          {!edit && (
            <Button disabled={!isFormValid} onClick={() => createWorkplace()}>
              {`Adicionar Local ${name ?? ''}`}
            </Button>
          )}
        </ButtonContainer>
      </Container>
    </>
  );
}
